import * as React from "react";
import { Box } from "@mui/material";
import { getPlatformBadgeVariants, platformFonts } from "../tickitPlatformTheme";
import { useThemeMode } from "../theme/ThemeModeProvider";

export default function PlatformBadge({ children, variant = "purple", icon }) {
  const { mode } = useThemeMode();
  const variants = getPlatformBadgeVariants(mode);
  const palette = variants[variant] || variants.purple;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: "9px",
        py: "3px",
        borderRadius: "20px",
        fontSize: "11.5px",
        fontWeight: 700,
        fontFamily: platformFonts.body,
        backgroundColor: palette.bg,
        color: palette.color,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      {icon}
      {children}
    </Box>
  );
}
